var _a;
import { useLayoutEffect, useEffect } from "react";
const isJSDom = typeof navigator !== "undefined" && ((_a = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : _a.includes("jsdom"));
const useIsomorphicLayoutEffect = typeof document !== "undefined" && !isJSDom ? useLayoutEffect : useEffect;
export {
  useIsomorphicLayoutEffect
};
